import { Injectable } from "@angular/core";
import { LocalStoreService } from "app/core/services/local-store.service";
import { HttpClient } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { map, catchError, delay } from "rxjs/operators";
import { User } from "../../models/user.model";
import { of, BehaviorSubject, throwError } from "rxjs";
import { environment } from "environments/environment";

// ================= only for demo purpose ===========
const DEMO_TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJjLnNvZnR3YXJlIiwianRpIjoiZDVlNWIwYTQtMGZlZS00NmUwLThlNzktNDMyN2M3NGIyNzI2IiwiZW1haWwiOiJkZXZAY2xldmVyc29mdHdhcmVncm91cC5jb20iLCJ1aWQiOiIxIiwiaXAiOiIxNzIuMjIuNDguMSIsInJvbGVzIjpbIlN1cGVyQWRtaW4iLCJBZG1pbiIsIk1vZGVyYXRvciIsIkJhc2ljIl0sImV4cCI6MTY1NTIwOTc5MiwiaXNzIjoiQ29yZUlkZW50aXR5IiwiYXVkIjoiQ29yZUlkZW50aXR5VXNlciJ9.XNmrT7_3lfuXVTBx7Fg3ZwvpPJONv3wtSvYDHkXSESM";

const DEMO_USER: User = {
  id: "5b700c45639d2c0c54b354ba",
  displayName: "Watson Joyce",
  role: "SA",
};
// ================= you will get those data from server =======

@Injectable({
  providedIn: "root",
})
export class DLMJwtAuthService {
  token;
  isAuthenticated: Boolean;
  user: User = {};
  user$ = new BehaviorSubject<User>(this.user);
  signingIn: Boolean;
  return: string;
  JWT_TOKEN =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJjLnNvZnR3YXJlIiwianRpIjoiNzk0YmRlMGMtODRmMC00NDI2LWJjMjAtOWRmZjAwYmU0NTIwIiwiZW1haWwiOiJkZXZAY2xldmVyc29mdHdhcmVncm91cC5jb20iLCJ1aWQiOiIxIiwiaXAiOiIxNzIuMjIuNDguMSIsInJvbGVzIjpbIlN1cGVyQWRtaW4iLCJBZG1pbiIsIk1vZGVyYXRvciIsIkJhc2ljIl0sImV4cCI6MTY1NTE5OTg0MiwiaXNzIjoiQ29yZUlkZW50aXR5IiwiYXVkIjoiQ29yZUlkZW50aXR5VXNlciJ9.LaFUloR_GxOq8GTUtoKb2r3p9Lv5LVjXjfJrLc3cINA";
  APP_USER = "dev@cleversoftwaregroup.com";

  constructor(
    private ls: LocalStoreService,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(
      (params) => (this.return = params["return"] || "/calibration/dashboard/workshop-dashboard")
    );
  }

  public signin(username, password) {
    return of({ token: DEMO_TOKEN, user: DEMO_USER }).pipe(
      delay(1000),
      map((res: any) => {
        this.setUserAndToken(res.token, res.user, !!res);
        this.signingIn = false;
        return res;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );

    // FOLLOWING CODE SENDS SIGNIN REQUEST TO SERVER

    // this.signingIn = true;
    // return this.http.post(`${environment.apiURL}/auth/local`, { username, password })
    //   .pipe(
    //     map((res: any) => {
    //       this.setUserAndToken(res.token, res.user, !!res);
    //       this.signingIn = false;
    //       return res;
    //     }),
    //     catchError((error) => {
    //       return throwError(error);
    //     })
    //   );
  }

  /*
    checkTokenIsValid is called inside constructor of
    shared/components/layouts/admin-layout/admin-layout.component.ts
  */
  public checkTokenIsValid() {
    return of(DEMO_USER).pipe(
      map((profile: User) => {
        this.setUserAndToken(this.getJwtToken(), profile, true);
        this.signingIn = false;
        return profile;
      }),
      catchError((error) => {
        return of(error);
      })
    );

    /*
      The following code get user data and jwt token is assigned to
      Request header using token.interceptor
      This checks if the existing token is valid when app is reloaded
    */

    // return this.http.get(`${environment.apiURL}/api/users/profile`)
    //   .pipe(
    //     map((profile: User) => {
    //       this.setUserAndToken(this.getJwtToken(), profile, true);
    //       return profile;
    //     }),
    //     catchError((error) => {
    //       this.signout();
    //       return of(error);
    //     })
    //   );
  }

  public signout() {
    this.setUserAndToken(null, null, false);
    this.router.navigateByUrl("sessions/signin");
  }

  isLoggedIn(): Boolean {
    return !!this.getJwtToken();
  }

  getJwtToken() {
    return this.ls.getItem(this.JWT_TOKEN);
  }
  getUser() {
    return this.ls.getItem(this.APP_USER);
  }

  setUserAndToken(token: String, user: User, isAuthenticated: Boolean) {
    this.isAuthenticated = isAuthenticated;
    this.token = token;
    this.user = user;
    this.user$.next(user);
    this.ls.setItem(this.JWT_TOKEN, token);
    this.ls.setItem(this.APP_USER, user);
  }
}
